class UserAdminController {

    constructor(
        $uibModal,
        CurrentUser,
        UserHelper,
        UserAdminService
    ){
        'ngInject';

        this.$uibModal = $uibModal;
        this.CurrentUser = CurrentUser;
        this.UserHelper = UserHelper;
        this.UserAdminService = UserAdminService;
    }

    $onInit() {
        this.isReverseSort = false;
        this.itemsPerPage = 50;
        this.sortIndex = 0;
        this.sortProp = null;
        this.sortPropDisplay = null;

        this.statusFilterOptions = [
            {name: 'All', filterVal: undefined},
            {name: 'User', filterVal: 'User'},
            {name: 'Holding', filterVal: 'Holding'},
            {name: 'Deactivated', filterVal: 'Deactivated'}
        ];
        this.selectedStatusFilter = this.statusFilterOptions[0];

        this.search = {
            email_addr: undefined,
            status: undefined,
            role: undefined
        };

        this.headers = [
            {
                text: 'User',
                columnSize: 'lg',
                showSort: true,
                nestedDisplayKeys: ['email_addr']
            },
            {
                text: 'Status',
                columnSize: 'md',
                showSort: true,
                nestedDisplayKeys: ['status']
            },
            {
                text: 'Role',
                columnSize: 'md',
                showSort: true,
                nestedDisplayKeys: ['role'],
                wrapWords: true
            },
            {
                text: 'Clients',
                columnSize: 'sm',
                showSort: false
            }
        ];

        this.sortColumns = this.headers.filter((header) => header.showSort);

        this.showError = false;
        this.errorMessage = '';

        this.roleFilterList = [{id: undefined, name: 'All'}].concat(this.roleList);
        this.selectedRoleFilter = this.roleFilterList[0];

        // A list of all of the permissions that show up in the Custom Permission modal
        this.customPermissions = this.permissionList
            .filter((p) => this.UserHelper.clientPermissions.indexOf(p.code) === -1);
    }

    /***
     * Open the Survey Settings modal.
     */
    openPreRegisterModal() {
        this.$uibModal.open({
            component: 'PreRegisterModal',
            size: 'md',
            windowClass: 'custom-modal pre-register-modal',
            resolve: {
                clientList: () => this.clientList,
                roleList: () => this.roleList,
                parentController: () => this

            }
        });
    }

    showErrorMessage(errorMessage) {
        this.errorMessage = errorMessage;
        this.showError = true;
    }

    hideError() {
        this.showError = false;
        this.errorMessage = '';
    }

    updateUserList() {
        this.UserAdminService.getUsers().then((successResponse) => {
            this.userList = successResponse;
        })
    }

    /***
     * Sort the list of users based on the given column ("email_addr" or "status").
     * Iterates through 3 sort states, tracked by this.sortIndex:
     * 0 - no sort
     * 1 - sort ascending
     * 2 - sort descending
     *
     * @param sortColumn    the column to sort the table by. Options are "User" and "Status"
     */
    sortList(sortColumnName) {
        const sortColumn = this.sortColumns.filter((column) => column.text === sortColumnName)[0];
        if (sortColumn === undefined) {
            return;
        }
        if (this.sortPropDisplay !== sortColumnName) {
            this.sortIndex = 0;
        }
        this.sortPropDisplay = sortColumnName;
        this.sortIndex = (this.sortIndex + 1) % 3;
        this.isReverseSort = this.sortIndex === 2;
        this.sortProp = this.sortIndex === 0 ? null : sortColumn.nestedDisplayKeys.join('.');
    }

    /***
     * A callback for the paginator component. Updates the ng-repeat list with the correct starting index, based on
     * the current page.
     *
     * @param startingIndex     the index within the array of items to start displaying in the list.
     */
    updatePaginationStartingIndex(startingIndex) {
        this.startingIndex = startingIndex;
    }

    /***
     * A callback for the dropdown boxes which are used to filter Users by their status. Updates the filter object to
     * filter results by the selected status.
     *
     * @param option    the name of the status being filtered
     */
    updateStatusFilter(option) {
        this.search.status = option.filterVal;
        this.selectedStatusFilter = option;
    }

    updateRoleFilter(item) {
        this.search.role = item.id;
        this.selectedRoleFilter = item;
    }

}

export default UserAdminController;


// WEBPACK FOOTER //
// ./app/components/user-admin/user-admin-controller.js